import { mergeMap, switchMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { SymbolGroupsAction } from '../symbolGroups.action';

type IDependencies = IClientApiDependencySegment;

export const loadSymbolGroupsEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(SymbolGroupsAction.load.started),
  switchMap(() => {
    return dependencies.api.getSymbolGroups({}).pipe(
      mergeMap((response) => {
        return [
          SymbolGroupsAction.load.done({ result: response.symbolGroups }),
        ];
      }),
      catchApiError((error) => {
        return [
          SymbolGroupsAction.load.failed({ error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
